import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:3001",
});

// Add a request interceptor
api.interceptors.request.use(
  function (config) {
    // Retrieve the token from wherever it is stored (e.g. localStorage, cookies, etc.)
    if (JSON.parse(localStorage.getItem("userInfo"))) {
      const data = JSON.parse(localStorage.getItem("userInfo"));
      console.log(data.token)
      // If a token exists, add it to the request headers
      if (data.token) {
        config.headers.authorization = `Bearer ${data.token}`;
      } else {
        return config;
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default api;
